import { DateCalendar } from "@mui/x-date-pickers"
import { observer } from "mobx-react-lite"
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Alert, Button, Snackbar, Stack, TextField, Typography } from "@mui/material";
import React, { useEffect } from "react";
import dayjs from 'dayjs';
import { CompanyCensus } from "../../../models/Setups/CompanyCensus";
import { useStore } from "../../../stores/store";
import { LoadingButton } from "@mui/lab";

export default observer(function CensusSetup() {
    const { setupsStore } = useStore();
    const { putCensusSetup, savingData, loadCompanyCensusData, getCompanyCensusData } = setupsStore;
    const [currentCensus, setCurrentCensus] = React.useState(80);
    const [selectedDate, setSelectedDate] = React.useState(new Date());
    const [openSuccess, setOpenSuccess] = React.useState(false);
    const handleUpdateCensus = (value: number) => {
        setCurrentCensus(value);
    }

    useEffect(() => {
        document.title = 'Company Census';
        loadCompanyCensusData();
    }, []);

// Effect to update currentCensus when selectedDate changes
useEffect(() => {
    if (selectedDate) {
      // Convert Map values to array and find matching census
      const matchingCensus = getCompanyCensusData.find(census => new Date(census.censusdate).toDateString() === new Date(selectedDate).toDateString());
      // Update currentCensus if matching census found
      if (matchingCensus) {        
        setCurrentCensus(matchingCensus.census);
      }
      else{
        setCurrentCensus(0);
      }
    }
  }, [selectedDate, getCompanyCensusData]);

    const handleCloseSnack = () => {
        setOpenSuccess(false);
    };

    const getCensusTitle = () => {
        return 'Census for ' + selectedDate.toDateString();
    }

    const previousDateClick = () => {
        const currentDate = new Date(selectedDate);
        const daysToAdd = 1;
        currentDate.setDate(currentDate.getDate() - daysToAdd);
        setSelectedDate(currentDate);
    }

    const nextDateClick = () => {
        const currentDate = new Date(selectedDate);
        const daysToAdd = 1;
        currentDate.setDate(currentDate.getDate() + daysToAdd);
        setSelectedDate(currentDate);
    }

    const saveCensusForDateClick = () => {
        const cono = window.localStorage.getItem('cono');
        if (!cono) {
            return
        }
        let census: CompanyCensus = { cono: cono, censusdate: selectedDate, census: currentCensus };
        putCensusSetup(census).then(() => {
            setOpenSuccess(true);
            loadCompanyCensusData();
        });
    }

    return (
        <>
            <Stack sx={{ alignContent: 'center', alignItems: 'center', }}>
                <Typography sx={{ fontSize: 22, marginTop: 1 }}>Company Census</Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateCalendar value={dayjs(selectedDate)} onChange={(newValue) => {
                        if (newValue == null) {
                            return;
                        }
                        setSelectedDate(newValue.toDate())
                    }} sx={{ marginTop: 2, marginBottom: 2, border: 1, borderRadius: 2, borderBlockColor: '#CDCDCD', borderLeftColor: '#CDCDCD', borderRightColor: '#CDCDCD' }} />
                </LocalizationProvider>
                <Stack direction={'row'}>
                    <Button variant="outlined" sx={{ width: 120, fontSize: 11, padding: 1 }} onClick={() => previousDateClick()}>Previous Date</Button>
                    <TextField value={currentCensus} size='small' type='number'
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            handleUpdateCensus(Number(event.target.value));
                        }}
                        sx={{ minWidth: 60, alignSelf: 'center', alignContent: 'center', alignItems: 'center', marginLeft: 3, marginRight: 3, marginTop: 1 }} id="outlined-basic"
                        label={getCensusTitle()} variant="outlined">

                    </TextField>
                    <Button variant="outlined" sx={{ width: 120, fontSize: 11, padding: 1 }} onClick={() => nextDateClick()}>Next Date</Button>
                </Stack>
                <LoadingButton loading={savingData} variant="contained" sx={{ width: 220, marginTop: 2 }} onClick={() => saveCensusForDateClick()}>Save Census For Date</LoadingButton>
            </Stack>
            <Snackbar open={openSuccess} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={2500} onClose={handleCloseSnack}>
                <Alert onClose={handleCloseSnack} severity="success" variant="filled" sx={{ fontSize: 24 }}>
                    Successfully Saved Census For Selected Date
                </Alert>
            </Snackbar>
        </>
    )
})